<template>
  <Dropdown>
    <template slot="toggler">
      <span class="btn btn-amount">
        Dorośli: {{ schema.totalAdults.$value }} &middot; Dzieci: {{ schema.totalChildren3.$value }} &middot; Pokoje:
        {{ schema.totalRooms.$value }}
      </span>
    </template>

    <DropdownContent #default="{ close }">
      <div class="amount-container">
        <div
          v-for="(occupancy, index) in schema.occupancy.$items"
          :key="'occupancy-amount-' + index"
          class="occupancy-container"
        >
          <Occupancy :index="index" :occupancy="occupancy.$item" @remove="removeOccupancy" />
        </div>
      </div>

      <div class="amount-buttons">
        <button class="btn btn-add" @click.stop="addOccupacy" :disabled="!allowAddOccupancy">+ Dodaj pokój</button>
        <button
          class="btn btn-primary"
          @click="
            changed();
            close();
          "
        >
          Gotowe
        </button>
      </div>
    </DropdownContent>
  </Dropdown>
</template>

<script>
import Dropdown from '@/components/core/Dropdown';
import DropdownContent from '@/components/core/DropdownContent';
import Occupancy from './Occupancy';
import reservationService from '@/services/reservation.service';

export default {
  components: { Dropdown, DropdownContent, Occupancy },
  props: {
    schema: { type: Object, required: true }
  },
  computed: {
    allowAddOccupancy() {
      return this.schema.occupancy.$items.length < reservationService.settings.maxNumberOfRooms;
    }
  },
  methods: {
    removeOccupancy(index) {
      this.schema.occupancy.$removeRow(index);
    },
    addOccupacy() {
      this.schema.occupancy.$addRow({});
    },
    changed() {
      this.$emit('hide');
      this.$emit('change');
    }
  }
};
</script>
